export default function CloseIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.778 18.647L2.868 31.556L0 28.687L12.909 15.778L0 2.868L2.868 0L15.778 12.909L28.687 0L31.557 2.868L18.647 15.778L31.557 28.687L28.687 31.557L15.778 18.647Z" fill="white" />
    </svg>
  )
}
